export function readStoredUserAuth() {
  try {
    const raw = localStorage.getItem('user_auth');
    return raw ? JSON.parse(raw) : {};
  } catch (error) {
    return {};
  }
}

export function loggedInRole(userDetails, storedAuth = {}) {
  if (userDetails && typeof userDetails === 'object' && userDetails.role) {
    return userDetails.role;
  }
  return storedAuth.role || localStorage.getItem('role') || '';
}

export function associatedProjectId({ userDetails, storedAuth } = {}) {
  return (userDetails && typeof userDetails === 'object' && userDetails.project_id)
    || storedAuth?.project_id
    || localStorage.getItem('project_id')
    || '';
}
